import { rawWages } from '../../../data/wageData_2021'
import { scaleLinear, scaleUtc } from 'd3-scale'
import { utcParse } from 'd3-time-format'
import { extent, min, max } from 'd3-array'
import { line, curveNatural } from 'd3-shape'
import { useSpring, animated } from 'react-spring'
import '../../../styles/wages.scss'

import { useDimensionsContext } from '../Chart'
import { XAxis, YAxis } from './Axes'

const Wages = ({ step, direction, fade }) => {
  const dimensions = useDimensionsContext()
  const parse = utcParse('%m/%d/%Y')
  const wagesFormatted = rawWages.map((wage) => {
    return {
      ...wage,
      Date: parse(wage.Date)
    }
  })

  const wages = wagesFormatted
    .map((item, i) => {
      return i % 4 === 0 ? item : null
    })
    .filter((item) => item)

  const isNarrow = dimensions.width < 450

  const x = scaleUtc(extent(wages.map((item) => item.Date)), [
    0,
    dimensions.boundedWidth
  ])

  const minPercent = min(wages.map((item) => item.Overall * 100))
  const maxPercent = max(wages.map((item) => item.Overall * 100))

  const y = scaleLinear(
    [minPercent - 0.25, maxPercent + 0.8],
    [dimensions.boundedHeight, 0]
  )

  const overallLine = line()
    .x((d) => x(d.Date))
    .y((d) => y(d.Overall * 100))
    .curve(curveNatural)

  const stayerLine = line()
    .x((d) => x(d.Date))
    .y((d) => y(d['Job Stayer'] * 100))
    .curve(curveNatural)

  const switcherLine = line()
    .x((d) => x(d.Date))
    .y((d) => y(d['Job Switcher'] * 100))
    .curve(curveNatural)

  const jobSwitcher = switcherLine(wages)
  const jobStayer = stayerLine(wages)
  const jobOverall = overallLine(wages)

  const animationConfig = {
    to: { one: jobSwitcher, two: jobStayer },
    from: { one: jobOverall, two: jobOverall },
    config: { duration: 750 },
    //delay: 1000,
    reset: true
  }

  const [animatedProps, setAnimatedProps] = useSpring(() => animationConfig)
  setAnimatedProps(animationConfig)

  return (
    <>
      <defs>
        <pattern
          id="pandemic-stripes"
          patternUnits="userSpaceOnUse"
          width="8"
          height="40"
          patternTransform="rotate(45 0 0)"
        >
          <line
            id="pandemic-stripes"
            className={`wages-pattern step-${step}`}
            y2="40"
          />
        </pattern>
      </defs>
      <XAxis x={x} />
      <YAxis y={y} />

      <g>
        <rect
          x={x(parse('3/12/20'))}
          width={x(parse('12/1/21')) - x(parse('3/12/20'))}
          height={dimensions.boundedHeight}
          fill="url(#pandemic-stripes)"
        />
        <text
          className={`wage-label detail step-${step} `}
          x={
            x(parse('3/12/20')) +
            (x(parse('12/1/21')) - x(parse('3/12/20'))) / 2
          }
          y={dimensions.boundedHeight - 20}
        >
          Pandemic
        </text>
        <path className={`wage overall step-${step}`} d={jobOverall} />
        <text
          className={`wage-label overall step-${step}`}
          x={x(wages[20].Date)}
          y={y(isNarrow ? 2 : 2.5)}
          dy=".35em"
          //textAnchor="end"
        >
          Overall
        </text>
        <text
          className={`wage-label overall step-${step}`}
          x={x(wages[20].Date)}
          y={y(isNarrow ? 2 : 2.5) + 20}
          dy=".35em"
          // textAnchor="end"
        >
          wage growth
        </text>
      </g>
      <g>
        <animated.path
          className={`wage switcher step-${step}`}
          d={
            step === 0 && direction === 'down' ? animatedProps.one : jobSwitcher
          }
          key="switcher"
        />
        <text
          className={`wage-label switcher step-${step}`}
          x={x(wages[isNarrow ? 0 : 5].Date)}
          y={y(3.5)}
          dy=".35em"
        >
          Job switcher
        </text>
        <text
          className={`wage-label switcher step-${step}`}
          x={x(wages[isNarrow ? 0 : 5].Date)}
          y={y(3.5) + 20}
          dy=".35em"
        >
          wage growth
        </text>
      </g>
      <g>
        <animated.path
          className={`wage stayer step-${step}`}
          d={
            //step === 1 && inFrame === 'in' && direction === 'down'
            step === 1 && direction === 'down' && !fade
              ? animatedProps.two
              : jobStayer
          }
          key="stayer"
        />

        <text
          className={`wage-label stayer step-${step}`}
          x={x(wages[20].Date) + 5}
          y={y(isNarrow ? 2 : 2.4)}
          dy=".35em"
        >
          Job stayer
        </text>
        <text
          className={`wage-label stayer step-${step}`}
          x={x(wages[20].Date) + 5}
          y={y(isNarrow ? 2 : 2.4) + 20}
          dy=".35em"
        >
          wage growth
        </text>
      </g>
    </>
  )
}

export default Wages
